export function sortArticlesByDateDesc(articles = []) {
  return [...articles].sort((left, right) => {
    return new Date(right.date).getTime() - new Date(left.date).getTime()
  })
}

export function getFeaturedArticles(articles = [], limit = 3) {
  return sortArticlesByDateDesc(articles).slice(0, limit)
}

export function getArchivedArticles(articles = [], featuredCount = 3) {
  return sortArticlesByDateDesc(articles).slice(featuredCount)
}

export function formatArticleDate(date) {
  return new Intl.DateTimeFormat('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date(date))
}

export function getArticlesByCategory(articles = [], category = 'Todos') {
  if (category === 'Todos') {
    return sortArticlesByDateDesc(articles)
  }
  return sortArticlesByDateDesc(
    articles.filter(article => article.category === category)
  )
}

export function getUniqueCategories(articles = []) {
  const categories = new Set(articles.map(article => article.category))
  const allCategories = Array.from(categories)
  
  // Orden personalizado: Prensa, Entrevistas, Voces, Archivo
  const order = ['Prensa', 'Entrevistas', 'Voces', 'Archivo']
  return order.filter(cat => cat === 'Voces' || allCategories.includes(cat))
}

export function sortArticles(articles = [], sortBy = 'date-desc') {
  const sorted = [...articles]
  
  switch (sortBy) {
    case 'date-desc':
      return sorted.sort((a, b) => new Date(b.date) - new Date(a.date))
    case 'date-asc':
      return sorted.sort((a, b) => new Date(a.date) - new Date(b.date))
    case 'name-asc':
      return sorted.sort((a, b) => a.title.localeCompare(b.title, 'es'))
    case 'name-desc':
      return sorted.sort((a, b) => b.title.localeCompare(a.title, 'es'))
    default:
      return sorted
  }
}
